import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IBusinessInquiryParams, IGetBusinessInquiries, IGetBusinessInquiry, IGetInquiryAnswer } from '../models/franchise.model';
import QueryString from 'qs';

const uri = '/mgmt/franchise';

export const getBusinessInquiries = (params: IBusinessInquiryParams): AxiosPromise<IGetBusinessInquiries> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}?${qsParams}`);
}

export const getBusinessInquiry = (inquiryCode: number): AxiosPromise<IGetBusinessInquiry> => {
  return axios.get(`${uri}/inquiry/${inquiryCode}`);
}

export const getInquiryAnswer = (inquiryCode: number): AxiosPromise<IGetInquiryAnswer> => {
  return axios.get(`${uri}/answer/${inquiryCode}`);
}

export const createInquiryAnswer = (inquiryCode: number, data: FormData): AxiosPromise => {
  return axios.post(`${uri}/answer/${inquiryCode}`, data);
}

export const updateInquiryAnswer = (inquiryCode: number, data: FormData): AxiosPromise => {
  return axios.put(`${uri}/modify/${inquiryCode}`, data);
}
